import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/category/layer/remove/layer.category.layer.remove.mutation.gql"
import type {
  LayerCategoryLayerRemoveMutation,
  LayerCategoryLayerRemoveMutationVariables,
} from "@/v2-backoffice-client/layer/category/layer/remove/__types__/layer.category.layer.remove.mutation"

type Options = MutationHookOptions<
  LayerCategoryLayerRemoveMutation,
  LayerCategoryLayerRemoveMutationVariables
>

export function useLayerCategoryLayerRemoveMutation(options?: Options) {
  return useMutation<
    LayerCategoryLayerRemoveMutation,
    LayerCategoryLayerRemoveMutationVariables
  >(mutation, options)
}
